import { defineMessages } from 'react-intl';

export default defineMessages({
  thisSectionRelatesToExpensesForYourBaggagePersonalItemsCashAndTravelDocuments: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.thisSectionRelatesToExpensesForYourBaggagePersonalItemsCashAndTravelDocuments',
    defaultMessage: 'This section relates to expenses for your baggage, personal items, cash and travel documents.',
  },

  areYouClaimingForDamagedLostOrStolenLuggage: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.areYouClaimingForDamagedLostOrStolenLuggage',
    defaultMessage: 'Are you claiming for Damaged, Lost, or Stolen Luggage?',
  },

  areYouClaimingForBaggageDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.areYouClaimingForBaggageDelay',
    defaultMessage: 'Are you claiming for Baggage Delay?',
  },

  areYouClaimingFor: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.areYouClaimingFor',
    defaultMessage: 'Place of Loss:',
  },

  areYouClaimingForV2: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.areYouClaimingFor',
    defaultMessage: 'Are you claiming for:',
  },

  travelSupplierProviderInformation: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.travelSupplierProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  companyYouWereTravelingWith: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.companyYouWereTravelingWith',
    defaultMessage: 'Company you were traveling with:',
  },

  origin: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.origin',
    defaultMessage: 'Origin',
  },

  airCarrier: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.airCarrier',
    defaultMessage: 'Air Carrier',
  },

  destination: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.destination',
    defaultMessage: 'Destination',
  },

  lossInformation: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.lossInformation',
    defaultMessage: 'Loss Information',
  },

  dateOfLoss: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },

  pleaseDescribeWhatOccurred: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please describe what occurred',
  },

  ifOtherPleaseDescribe: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.ifOtherPleaseDescribe',
    defaultMessage: 'If other, please describe',
  },

  ifOtherPleaseDescribeWhere: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.ifOtherPleaseDescribe',
    defaultMessage: 'If other, please describe where',
  },

  whoDidYouReportTo: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.whoDidYouReportTo',
    defaultMessage: 'Who did you report to?',
  },

  reportReferenceNumber: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },

  nameAndAddress: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.nameAndAddress',
    defaultMessage: 'Name and Address',
  },

  nameCustomerServiceDepartment: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.nameCustomerServiceDepartment',
    defaultMessage: 'Name (Customer Service Department)',
  },

  doYouHaveAnyFurtherDetailsToAdd: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.doYouHaveAnyFurtherDetailsToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },

  loss: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.loss',
    defaultMessage: 'Loss',
  },

  theft: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.theft',
    defaultMessage: 'Theft',
  },

  damage: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.damage',
    defaultMessage: 'Damage',
  },

  tourOperator: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.tourOperator',
    defaultMessage: 'Tour Operator',
  },

  cruiseLine: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.cruiseLine',
    defaultMessage: 'Cruise Line',
  },

  airline: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.airline',
    defaultMessage: 'Airline',
  },

  airport: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.airport',
    defaultMessage: 'Airport',
  },

  hotel: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.hotel',
    defaultMessage: 'Hotel',
  },

  rentalAgency: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.rentalAgency',
    defaultMessage: 'Rental Agency',
  },

  other: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.other',
    defaultMessage: 'Other',
  },

  police: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.police',
    defaultMessage: 'Police',
  },

  hospitalManagement: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.hospitalManagement',
    defaultMessage: 'Hospital Management',
  },

  cruiseShip: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },

  tourGuide: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.tourGuide',
    defaultMessage: 'Tour Guide',
  },

  notReported: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.notReported',
    defaultMessage: 'Not Reported',
  },

  addItem: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.addItem',
    defaultMessage: 'Add Expense',
  },

  itemWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  item: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.item',
    defaultMessage: 'Item',
  },

  estimatedValue: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.estimatedValue',
    defaultMessage: 'Actual Cost',
  },

  currency: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.currency',
    defaultMessage: 'Currency',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received Reimbursement?',
  },

  dateReimbursementReceived: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  fromWhom: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  howMuch: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.howMuch',
    defaultMessage: 'How much?',
  },

  totalExpensesClaimed: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.totalExpensesClaimed',
    defaultMessage: 'Total Expenses Claimed',
  },

  yes: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.no',
    defaultMessage: 'No',
  },

  // ------------------------------------------------------------------------------------

  tripCancellation: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  travelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.travelInterruption',
    defaultMessage: 'Are you claiming for Travel Interruption?',
  },

  travelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasons2',
    defaultMessage: 'You Unforeseen Sickness or Injury or, the Sickness or Injury if a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity a Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country',
  },

  reasons4: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasons4',
    defaultMessage: 'or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplierWhereDelayOccurred: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.travelSupplierWhereDelayOccurred',
    defaultMessage: 'Travel Supplier/Provider where delay occurred',
  },
  travelSupplier: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  addressTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  includedInPackage: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  addLossInformation: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruse/travel agent/ect.)',
  },

  amountPaidLoss: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.amountPaidLoss',
    defaultMessage: 'Amount Paid (total for all insureds)',
  },

  amountOfLoss: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  reasonsForDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident en router to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateOfInitialPaymentDeposit: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateDelayEnded: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },

  haveYouMadeAClaimWithYourTravelProvider: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.delayInformationWithIdx',
    defaultMessage: 'Have you made a claim with your Travel provider?',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  delay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.delay',
    defaultMessage: 'Delay',
  },
  hotelManagement: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  otherDescription: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  descriptionOfItems: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.descriptionOfItems',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  amountClaimed: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  claimed: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was due for return',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was due for return',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  doYouHaveAnyOtherTypeOfInsurance: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.doYouHaveAnyOtherTypeOfInsurance',
    defaultMessage: 'Do you have any other type of insurance?',
  },
  companyName: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.companyName',
    defaultMessage: 'Company Name',
  },
  address: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.address',
    defaultMessage: 'Address',
  },
  cityOrTown: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.cityOrTown',
    defaultMessage: 'City or Town',
  },
  country: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.country',
    defaultMessage: 'Country',
  },
  postalCode: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.postalCode',
    defaultMessage: 'Postal Code',
  },
  policy: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.policy',
    defaultMessage: 'Policy #',
  },
  typeOfPolicy: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },
  contact: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.contact',
    defaultMessage: 'Contact',
  },
  phoneNumber: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.phoneNumber',
    defaultMessage: 'Phone Number',
  },
  ageOfItem: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.ageOfItem',
    defaultMessage: 'Age of Item',
  },
  costOfReplacement: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.costOfReplacement',
    defaultMessage: 'Cost of Replacement',
  },
  originalCost: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.originalCost',
    defaultMessage: 'Original Cost',
  },
  dateOfPurchase: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.dateOfPurchase',
    defaultMessage: 'Date Of Purchase',
  },
  depreciationType: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.depreciationType',
    defaultMessage: 'Depreciation Type',
  },
  pleaseSelectTheItemYouAreClaimingFor: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.pleaseSelectTheItemYouAreClaimingFor',
    defaultMessage: 'Please Select The Item You Are Claiming For:',
  },
  itemType: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.itemType',
    defaultMessage: 'Item Type',
  },
  descriptionOfValuables: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.descriptionOfValuables',
    defaultMessage: 'Description Of Valuables',
  },
  amountAUD: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.amountAUD',
    defaultMessage: 'Amount (AUD)',
  },
  expenseFor: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.selectInsuredForExpense',
    defaultMessage: 'Select all of the Insured(s) that relates to this expense',
  },
  departureDate: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.departureDate',
    defaultMessage: 'Departure Date',
  },
  reportDate: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.reportDate',
    defaultMessage: 'Report Date',
  },
  organizationNameReportedTo: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.organizationNameReportedTo',
    defaultMessage: 'Organization name reported to',
  },

  flightSearchRequiredFields: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.requiredFields',
    defaultMessage: 'Please complete all required fields.',
  },
  flightNotFound: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.notFound',
    defaultMessage: "We couldn't find a flight with the provided information. Please check the number and date.",
  },
  invalidFlightNumber: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.invalidNumber',
    defaultMessage: 'Flight number must follow the format: AA123.',
  },
  apiError: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.apiError',
    defaultMessage: "We couldn't connect to the flight verification system. Please try again later.",
  },
  useFlightInfo: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.useInfo',
    defaultMessage: 'Use this flight information for my claim',
  },

  flightNumber: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.flightNumber',
    defaultMessage: 'Flight Number',
  },
  flightDate: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.flightDate',
    defaultMessage: 'Flight Date',
  },
  checkFlightDate: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.checkFlightDate',
    defaultMessage: "'{defaultMessage}' cannot be more than 1 year in the past or future.",
  },
  checkFlightNumber: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.checkFlightNumber',
    defaultMessage: "'{defaultMessage}' Format: 2 letters + 1–4 digits (regex).",
  },
  flightDetails: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.flightDetails',
    defaultMessage: 'Flight Details',
  },
  searchSuccess: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.searchSuccess',
    defaultMessage: 'Search Success',
  },
  departure: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.departure',
    defaultMessage: 'Departure',
  },
  arrival: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.arrival',
    defaultMessage: 'Arrival',
  },
  pendingFlightApiRequest: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.pendingFlightApiRequest',
    defaultMessage: 'Searching for flight details, please wait a moment...',
  },
  pleaseEnterYourFlightNumberAndDateBelow: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.pleaseEnterYourFlightNumberAndDateBelow',
    defaultMessage: 'Please enter your flight number and date below',
  },
  manuallyEnterFlight: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.manuallyEnterFlight',
    defaultMessage: 'Manually Enter Flight',
  },
  typeOfTransport: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.typeOfTransport',
    defaultMessage: 'Type of Transport',
  },
  cruiseNumber: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.cruiseNumber',
    defaultMessage: 'Cruise Number',
  },
  arrivalDate: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.arrivalDate',
    defaultMessage: 'Arrival Date',
  },
  departurePort: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.departurePort',
    defaultMessage: 'Departure Port',
  },
  arrivalPort: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.arrivalPort',
    defaultMessage: 'Arrival Port',
  },
  pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled',
    defaultMessage: 'Please describe details of your journey and what was cancelled',
  },
  transportService: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.transportService',
    defaultMessage: 'Transport Service',
  },
  departureLocation: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.departureLocation',
    defaultMessage: 'Departure Location',
  },
  descriptionOfTravelType: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.descriptionOfTravelType',
    defaultMessage: 'Description of travel type',
  },
  descriptionOfEvent: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.descriptionOfEvent',
    defaultMessage: 'Description of event',
  },
  originAirport: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.originAirport',
    defaultMessage: 'Origin Airport',
  },
  destinationAirport: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.destinationAirport',
    defaultMessage: 'Destination Airport',
  },
  scheduledOut: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.scheduledOut',
    defaultMessage: 'Scheduled Out',
  },
  scheduledIn: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.scheduledIn',
    defaultMessage: 'Scheduled In',
  },
  departureDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.departureDelay',
    defaultMessage: 'Departure Delay (mins)',
  },
  arrivalDelay: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.arrivalDelay',
    defaultMessage: 'Arrival Delay (mins)',
  },
  status: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.status',
    defaultMessage: 'Flight Status',
  },
  cancelled: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.cancelled',
    defaultMessage: 'Was the flight cancelled?',
  },
  pleaseSelectYourFlightBelow: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.pleaseSelectYourFlightBelow',
    defaultMessage: 'Plsease select your flight below:',
  },
  scheduledDeparture: {
    id: 'fastCover.stepBaggageAndPersonalItemsStarr.scheduledDeparture',
    defaultMessage: 'Scheduled Departure',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/messages.js